<template>
  <div class=" is-fullwidth">
    <div v-if="garment_id == 0">
      <div class="is-pulled-left">
        <button class="button" :class="{'is-success' : this.include_hidden == true}" @click="updateIncludeHidden()">Include Hidden</button>
      </div>
      <div class="is-pulled-right mb-2" v-if="loading == false && garments.length > 0">
            
            <input class="input" v-model="search" placeholder="search garments ..."/>
            
        </div>
        <br style="clear:both" />
      <div class="notification is-info" v-if="loading === true">Loading garments ...</div>
      <div class="notification is-warning" v-if="loading == false && filteredGarments.length == 0">There are now garments to show</div>

      
      <div v-if="loading == false && filteredGarments.length > 0">
          
          <table class="table is-hoverable is-fullwidth is-size-7" id="garmentstable" >
            <thead>
              <th width="45">ID</th>
              <th>Garment Name</th>
              <th>General Range</th>
              <th>SKU Range/Code</th>
              <th>Style/Code</th>
              
              <th>F/P</th>
              <th>P/P</th>
              <th>C/S</th>
              <th>Approved</th>
              <th>Added to DB</th>
                      <th width="60">&nbsp;</th>
                      <th width="60">&nbsp;</th>
                
            </thead>
            <tbody>
                  <tr v-for="row in filteredGarments" v-bind:key="row.garmentID" :class="{'has-background-success' : row.approved == 1, 'has-text-white' : row.approved == 1}">
                    <td >{{row.garmentID}}</td>
                    <td >{{row.garmentname}}</td>
                      
                      <td>{{row.range}}</td>
                      <td>{{row.sku_range_name }} / {{  row.sku_range_code }}</td>
                      <td>{{row.style_name }} / {{  row.style_code }}</td>
                      <td>
                        <span class="icon " v-if="row.garment_fully_printed == 1">
                          <i class="fa fa-check"></i>
                      </span>
                      </td>
                      <td>
                        <span class="icon " v-if="row.garment_part_printed == 1">
                          <i class="fa fa-check"></i>
                      </span>
                      </td>
                      <td>
                        <span class="icon " v-if="row.garment_cut_sew == 1">
                          <i class="fa fa-check"></i>
                      </span>
                      </td>
                      <td><div v-if="row.approved == 1">Yes</div></td>
                      <td>{{  row.created_at }}</td>
                      <td>
                          <button class="button is-danger is-small" :disabled="working==true" @click="hideGarment(row)" v-if="row.hidegarment===0 || row.hidegarment=== null">Hide</button>
                          <button class="button is-link is-small" :disabled="working==true" @click="unhideGarment(row)" v-if="row.hidegarment==1">Un-hide</button>
                        </td>
                      <td><button class="button is-small is-info" :disabled="working==true" @click="loadGarment(row.garmentID)">View</button></td>

            </tr>
            </tbody>
          </table>
        </div>
      
    </div>

    <div v-if="garment_id > 0">
      <div class="notification is-info" v-if="loading == true">Loading garment details ...</div>
      <div v-if="loading == false">
        <div class="is-pulled-right"><button class="button is-info is-small" @click="goBack()">Back to List </button></div><br /><br />
        <div class="box">	
              <form @submit.prevent="updateGarment">
                  <div class="field">
                        <label class="label">Garment Name</label>
                        <div class="control">
                          {{ garment.garmentname }}
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Range </label>
                        <div class="control">
                          {{ garment.range }}
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">David's SKU Range </label>
                        <div class="control">
                          {{ garment.sku_range_name}} ({{ garment.sku_range_code}})
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">David's Style </label>
                        <div class="control">
                          {{ garment.style_name}}  ({{ garment.style_code}})
                        </div>
                    </div>
    
                   
                    <div class="field is-grouped" v-if="garment.approved == 0">
                        <div class="control">
                            <button class="button is-success" :disabled="working===true" @click="updateApproved()">Approve Garment to Show On CAD Upload Screen</button>
                        </div>
                    </div>
                    <div class="field is-grouped" v-if="garment.approved == 1">
                        <div class="control">
                            <button class="button is-danger" :disabled="working===true" @click="updateApproved()">Un Approve Garment to Hide On CAD Upload Screen</button>
                        </div>
                    </div>
                </form>
              
            </div>

            <div class="box" v-if=" (garment.sku_range_id == 0) && (garment.style_id == 0)">	
              <h4 class="title is-4">Setting Up Range And Style</h4>
                  <form class="form" @submit.prevent="updateRangeStyle()">
                    <div class="field">
                      <label class="label">Range</label>
                      <div class="select">
                        <select v-model="sku_range_id" class="" required>
                            <option value="">Please select range</option>
                            <option v-for="row in sku_ranges" :value="row.id" :key="row.id">{{  row.name }} / {{ row.code}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Style</label>
                      <div class="select">
                        <select v-model="style_id" class="" required>
                            <option value="">Please select style</option>
                            <option v-for="row in styles" :value="row.id" :key="row.id">{{  row.name }} / {{ row.code}}</option>
                        </select>
                      </div>
                    </div>
                    
                    
                    <div class="control">
                      <button type="submit" class="button is-success" :disabled="working==true">Update</button>
                    </div>
                  </form>
            </div>

            <div class="box">	
              <h4 class="title is-4">Garment Options</h4>
                <div class="field is-grouped">
                  <div class="buttons">
                      <button class="button " :disabled="working===true" :class="{'is-success':garment.garment_fully_printed==1}" @click="updateFullyPrinted()">Fully Printed</button>
                      <button class="button " :disabled="working===true" :class="{'is-success':garment.garment_part_printed==1}" @click="updatePartPrinted()">Part Printed</button>
                      <button class="button " :disabled="working===true" :class="{'is-success':garment.garment_cut_sew==1}" @click="updateCutSew()">Cut & Sew</button>
                  </div>
                  
                  
              </div>
              <small>If the button is green, the option will be available to the user</small>
            </div>

            <div class="box">	
              <h4 class="title is-4">Fabrics</h4>
              <div class="notification is-warning" v-if="this.garment.fabrics.length==0">This garment has no fabrics listed. If it is approved, the user will be able to select from ANY of the fabrics available in the database.</div>
            
              <table class="table is-striped is-fullwidth is-hoverable" v-if="this.garment.fabrics.length>0">
                <thead>
                  <tr>
                    <th>Fabric Name</th>
                    <th width="50">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in this.garment.fabrics" :key="row.id">
                    <td>{{ row.fabric_name }}</td>
                    <td><button class="button is-small is-danger" @click="deleteGarmentFabric(row.id)">Delete</button></td>
                  </tr>
                </tbody>
              </table>
              
              <form @submit.prevent="saveGarmentFabric">
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="fabric_id" required>
                        <option value="">Please select ... </option>
                        <option :value="row.id" v-for="row in fabrics" :key="row.id">{{ row.name }}</option>
                        
                      </select>
                    </div>
                  </div>
                  <div class="control">
                    <button type="submit" class="button is-primary">Add Fabric</button>
                  </div>
                </div>
                </form>

            </div>

            <div class="box">	
              <h4 class="title is-4">Recent Orders (maximum 100)</h4>
              <div class="notification is-warning" v-if="this.garment.orders.length==0">This garment has no recent orders listed.</div>
            
              <table class="table is-striped is-fullwidth is-hoverable" v-if="this.garment.orders.length>0">
                <thead>
                  <tr>
                    <th>PO Number</th>
                    <th>Order Date</th>
                    <th>Design Name</th>
                    <th width="50">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in this.garment.orders" :key="row.id">
                    <td>{{ row.ponumber }}</td>
                    <td>{{ row.orderdate }}</td>
                    <td>{{ row.designname }}</td>
                    <td><a :href="ASP_URL + '/printorder.asp?txtPONumber=' + row.ponumber" target="_blank"><button class="button is-small is-link" >View</button></a></td>
                  </tr>
                </tbody>
              </table>

              
              <div class="notification is-danger" v-if="this.garment.garmentID == 42">
                You cannot change the orders using Historical LW
              </div>

              <div class="notification is-danger" v-else-if="this.garment.orders.length > 50">
                This garment has more than 50 orders. It's not recommended to change over this number without speaking to David first.
              </div>

              <div v-else-if="this.garment.orders.length>0">
                <h3 class="title is-4" >Change Orders To Alternative Garment</h3>
                <p>Select the new garment from the list below and press Update to change all orders using this garment to the new one.</p>
                <form @submit.prevent="updateGarmentOrders">
                  <div class="field has-addons">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="new_garment_id" required>
                          <option value="">Please select ... </option>
                          <option :value="row.garmentID" v-for="row in approved_garments" :key="row.garmentID">{{ row.garmentname }}</option>
                          
                        </select>
                      </div>
                    </div>
                    <div class="control">
                      <button type="submit" class="button is-primary" :disabled="new_garment_id == null || new_garment_id == '' || working == true">Update</button>
                    </div>
                  </div>
                </form>
              </div>
             

            </div>

            <div class="box">	
              <h4 class="title is-4">Size Restrictions</h4>
              <p>Tick the boxes below to specify what sizes this garment can be ordered for on the red sales system. If no sizes are ticked, the garment will use the default system sizes for that range.</p>
              
              <div class="columns pt-4">
                  <div class="column">
                    <h2 class="title is-size-5">Childrens Sizes</h2>
                    <table class="table is-striped is-fullwidth is-hoverable">
                      
                      <tbody>
                        <tr v-for="row in this.childrens_sizes" :key="row.id">
                          <td>{{ row.name }}</td>
                          <td><input type="checkbox"  :checked="row.garment_id > 0" v-model="row.checked" @click="updateGarmentSize(row.id, row.checked)"/></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
               

                <div class="column">
                    <h2 class="title is-size-5">Adults Mens</h2>
                    <table class="table is-striped is-fullwidth is-hoverable">
                      
                      <tbody>
                        <tr v-for="row in this.mens_sizes" :key="row.id">
                          <td>{{ row.name }}</td>
                          <td><input type="checkbox"  :checked="row.garment_id > 0" v-model="row.checked" @click="updateGarmentSize(row.id, row.checked)"/></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                

                <div class="column">
                    <h2 class="title is-size-5">Adult Ladies</h2>
                    <table class="table is-striped is-fullwidth is-hoverable">
                      
                      <tbody>
                        <tr v-for="row in this.ladies_sizes" :key="row.id">
                          <td>{{ row.name }}</td>
                          <td><input type="checkbox"  :checked="row.garment_id > 0" v-model="row.checked" @click="updateGarmentSize(row.id, row.checked)"/></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              
            </div>

            <div class="box">	
              <h4 class="title is-4">Pricing For Dublin Report</h4>
                  <form class="form" @submit.prevent="updatePricingDublin">
                    <div class="field">
                      <label class="label">Junior Price</label>
                      <div class="control">
                        <input class="input" type="number" step=".01" placeholder="Junior Price" v-model="garment.pricing_junior" required>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Kids Price</label>
                      <div class="control">
                        <input class="input" type="number" step=".01" placeholder="Kids Price" v-model="garment.pricing_kids" required>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Adult Price</label>
                      <div class="control">
                        <input class="input" type="number" step=".01" placeholder="Adult Price" v-model="garment.pricing_adults" required>
                      </div>
                    </div>
                    <div class="control">
                      <button type="submit" class="button is-primary" :disabled="working==true">Update</button>
                    </div>
                  </form>
            </div>
      </div>

      
    
    </div>
    
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      garments: [],
      approved_garments: [],
      garment : [],
      garment_id: 0,
      search: '',
      garment_fully_printed: '',
      garment_cut_sew: '',
      garment_part_printed: '',
      approved: '',
      working: false,
      fabrics : [],
      fabric_id: '',
      accessToken: '',
      include_hidden: false,
      new_garment_id: '',
      sku_ranges: [],
      styles: [],
      sku_range_id: '',
      style_id: '',
      sizes: []
      
    }
  },
   methods: {
    async updateGarmentSize(size_id, newValue) {
        this.working = true

        var formdata = { 
              garment_id: this.garment.garmentID,
              size_id: size_id
          }; 

        if(newValue == false) {
          // We are turning on the value
          OrderService.saveGarmentSize(this.accessToken, formdata)
          .then(() => {
              this.working = false
              //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the sizes have not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
        else {
          // We are turning off the value
          // We are turning on the value
          OrderService.removeGarmentSize(this.accessToken, formdata)
          .then(() => {
              this.working = false
              //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the sizes have not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }

          

          
    },
    goBack() {
      this.garment_id = 0
      this.getGarments();
    },
    updateIncludeHidden()
    {
        this.include_hidden = !this.include_hidden
        this.getGarments()
    },
      async getGarments() {
        this.loading = true;
        UtilityService.getSimpleApiData(this.accessToken, "garments?order_by=created_at DESC&include_hidden=" + this.include_hidden).then(
               response => {
                this.garments = response 
                this.loading = false;
               }
            );
      },
      async getFabrics() {
        UtilityService.getSimpleApiData(this.accessToken, "fabrics").then(
               response => {
                this.fabrics = response 
                
               }
            );
      },
      async getSingleGarment() {
        this.loading = true;
        UtilityService.getSimpleApiData(this.accessToken, "garments/" + this.garment_id).then(
               response => {
                this.garment = response 
                this.getSizesForGarment();
               }
            );

            UtilityService.getSimpleApiData(this.accessToken, "garments?order_by=garmentname ASC&include_hidden=false&approved=1").then(
               response => {
                this.approved_garments = response 
                
               }
            );
            
            this.working = false
            this.loading = false;
      },
      async loadGarment(id)
      {
        this.garment_id = id
        this.getSingleGarment()
       
        
      },
    
      async updateFullyPrinted() {
        this.working = true

        if(this.garment.garment_fully_printed == 1)
        {
            this.garment_fully_printed = 0
        }
        else{
            this.garment_fully_printed = 1
        }

        var formdata = { 
            _method: 'patch',
            garment_fully_printed: this.garment_fully_printed
        }; 

        OrderService.updateGarment(this.accessToken, this.garment.garmentID, formdata)
        .then(() => {
            this.garment.garment_fully_printed = this.garment_fully_printed
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updatePartPrinted() {
        this.working = true

        if(this.garment.garment_part_printed == 1)
        {
            this.garment_part_printed = 0
        }
        else{
            this.garment_part_printed = 1
        }

        var formdata = { 
            _method: 'patch',
            garment_part_printed: this.garment_part_printed
        }; 

        OrderService.updateGarment(this.accessToken, this.garment.garmentID, formdata)
        .then(() => {
            this.garment.garment_part_printed = this.garment_part_printed
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updateRangeStyle()
    {
        this.working = true

        var formdata = { 
            _method: 'patch',
            sku_range_id: this.sku_range_id,
            style_id : this.style_id
        }; 

        OrderService.updateGarment(this.accessToken, this.garment.garmentID, formdata)
        .then(() => {
            this.loadGarment(this.garment.garmentID)
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async hideGarment(garment) {
        this.working = true

        var formdata = { 
            _method: 'patch',
             hidegarment: 1
        }; 

        OrderService.updateGarment(this.accessToken, garment.garmentID, formdata)
        .then(() => {
            garment.hidegarment = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async unhideGarment(garment) {
        this.working = true

        var formdata = { 
            _method: 'patch',
             hidegarment: 0
        }; 

        OrderService.updateGarment(this.accessToken, garment.garmentID, formdata)
        .then(() => {
            garment.hidegarment = 0
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updateGarmentOrders() {
      this.working = true

      var formdata = { 
            existing_garment_id : this.garment.garmentID,
             new_garment_id: this.new_garment_id
        }; 

        OrderService.updateGarmentOrders(this.accessToken, formdata)
        .then(() => {
          this.getSingleGarment()
            
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the orders have not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updateCutSew() {
        this.working = true

        if(this.garment.garment_cut_sew == 1)
        {
            this.garment_cut_sew = 0
        }
        else{
            this.garment_cut_sew = 1
        }

        var formdata = { 
            _method: 'patch',
            garment_cut_sew: this.garment_cut_sew
        }; 

        OrderService.updateGarment(this.accessToken, this.garment.garmentID, formdata)
        .then(() => {
            this.garment.garment_cut_sew = this.garment_cut_sew
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updateApproved() {
        this.working = true

        if(this.garment.approved == 1)
        {
            this.approved = 0
        }
        else{
            this.approved = 1
        }

        var formdata = { 
            _method: 'patch',
             approved: this.approved
        }; 

        OrderService.updateGarment(this.accessToken, this.garment.garmentID, formdata)
        .then(() => {
            this.garment.approved = this.approved
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updatePricingDublin() {
        this.working = true

        var formdata = { 
          garment_id : this.garment.garmentID,
             pricing_junior: this.garment.pricing_junior,
             pricing_kids: this.garment.pricing_kids,
             pricing_adults: this.garment.pricing_adults
        }; 

        OrderService.updateGarmentPricingDublin(this.accessToken, formdata)
        .then(() => {
             this.working = false
             alert("Pricing has been updated successfully")
             this.goBack();
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the garment has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async saveGarmentFabric() {
       this.working = true

       
        var formdata = { 
            fabric_id: this.fabric_id,
            garment_id: this.garment_id
        }; 

        OrderService.saveGarmentFabric(this.accessToken, formdata)
        .then(() => {
            this.working = false
            this.getSingleGarment()
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async deleteGarmentFabric(garment_fabric_id) {
       this.working = true

       var formdata = { 
            garment_id: this.garment_id
        };
       
        OrderService.deleteGarmentFabric(this.accessToken, garment_fabric_id, formdata)
        .then(() => {
            this.working = false
            this.getSingleGarment()
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async getSizesForGarment() {
        UtilityService.getSimpleApiData(this.accessToken, "sizes?garment_id=" + this.garment.garmentID).then(
                response => this.sizes = response 
            );
      },
    
  },
  computed : {
    filteredGarments: function () {
       
        let filteredGarments =  this.garments.filter(function(u) {
            if(  u.garmentEnabled == 1) 
            {
              return 1
            }
            
          })

          if(this.search != '' && this.search != null)
          {
            filteredGarments = filteredGarments.filter(row => row.garmentname.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredGarments
       
     },
     childrens_sizes: function () {
        let childrens_sizes =  this.sizes.filter(function(u) {
            if(  u.junior == 1 || u.kids == 1) 
            {
              return 1
            }
            
          })

          return childrens_sizes
     },
     mens_sizes: function () {
        let mens_sizes =  this.sizes.filter(function(u) {
            if(  u.adults == 1 && u.ladies == 0) 
            {
              return 1
            }
            
          })

          return mens_sizes
     },
     ladies_sizes: function () {
        let ladies_sizes =  this.sizes.filter(function(u) {
            if(  u.adults == 1 && u.ladies == 1) 
            {
              return 1
            }
            
          })

          return ladies_sizes
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getGarments();
           this.getFabrics();
           this.getSkuRanges();
           this.getStyles();
           
           
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

